import { DOCUMENT } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { APP_CONFIG } from "@Core/config/app-config";
import { TranslateLoader } from "@ngx-translate/core";
import { catchError, filter, Observable, tap } from "rxjs";

/**
 * Custom loader for microcopy.
 * Tries to load from DOT API, if error
 * loads files from locale.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {

  private readonly config = inject(APP_CONFIG);

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const microcopyUrl = `${this.config.dotDotDotApiUrl}/public/cached/microcopy/b2c/${lang}/`;

    return this.http.get(microcopyUrl)
    .pipe(
      tap((res) => {
        if(!res || (Array.isArray(res) && res.length === 0)) throw new Error('Empty remote microcopy')
      }),
      catchError((_err) => {
        const baseHref = this.document.baseURI;
        const i18nPath = `${baseHref}assets/i18n/${lang}.json`;
        return this.http.get(i18nPath);
      })
    );
  }

}
